/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-27 11:26:02
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Link, Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';
import { getShop, buildRedirectUrl } from 'src/helpers';

type Props = {
  active: boolean,
  onToggleModal: Function,
  widgetId: number,
  widgetName: string,
  actionType: string,
  loading: boolean,
  onAction: Function
};

type ComposedProps = Props & WithI18nProps;
// DONE
class ConfirmActionModal extends Component<ComposedProps> {
  render() {
    const { i18n, active, actionType, onToggleModal, loading, onAction, widgetName } = this.props;
    if (_.isEmpty(actionType)) {
      return '';
    }

    return (
      <Modal
        open={active}
        onClose={onToggleModal}
        title={i18n.translate(`AdminHTML.Recommendation.WidgetDashboard.${actionType}Widget_Title`)}
        primaryAction={{
          content: i18n.translate(
            `AdminHTML.Recommendation.WidgetDashboard.${actionType}Widget_Button`
          ),
          onAction: onAction,
          loading: loading
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: onToggleModal
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate(
                `AdminHTML.Recommendation.WidgetDashboard.${actionType}Widget_Content`,
                {
                  nt: <TextStyle variation="strong">"{widgetName}"</TextStyle>,
                  t1:
                    actionType === 'launch' ? (
                      <Link onClick={() => this.openGuide()}>
                        {i18n.translate(
                          `AdminHTML.Recommendation.WidgetDashboard.${actionType}Widget_Content_t1`
                        )}
                      </Link>
                    ) : (
                      ''
                    )
                }
              )}
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  openGuide = () => {
    const shop = getShop();
    const redirectUrl = buildRedirectUrl(shop, routes.recommendationWidgets.guide());

    window.open(redirectUrl, '_blank');
  };
}

export default withI18n()(ConfirmActionModal);
